import axios from 'axios';

export const BASE_URL = 'https://ayumedix.com/ecom-api';
// export const BASE_URL = 'http://localhost/ecom-api';

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include token in Authorization header
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    // console.log('Request interceptor - Token:', token);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      // console.log('Authorization header set:', config.headers.Authorization);
    }
    // console.log('Request config headers:', config.headers);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle 401 unauthorized responses
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      window.dispatchEvent(new Event('authStateChanged'));
      window.location.href = '/signin';
    }
    return Promise.reject(error);
  }
);

export const userAPI = {
  register: (userData) => api.post('/user/user.php', userData),
  update: (userData) => api.put('/user/user.php', userData),
  login: (credentials) => api.post('/auth/login.php', credentials),
  verifyOTP: (otpData) => api.post('/user/verify-otp.php', otpData),
};

export const productAPI = {
  getProducts: () => api.get('/product/'),
};

export const paymentAPI = {
  initiateCheckout: (data) => api.post('/payment/initiate-checkout', data),
  createOrder: (data) => api.post('/payment/create-order', data),
  uploadProof: (formData) => {
    return api.post('/payment/submit-proof', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  verifyPayment: (data) => api.post('/payment/verify', data),
  getPaymentStatus: (orderId) => api.get(`/payment/status?order_id=${orderId}`),
  getAllOrders: (userId) => api.get(`/user-orders/?user_id=${userId}`),
  updateOrderQuantity: (data) => api.post('/payment/update-qty', data)
};

export const authAPI = {
  login: (credentials) => api.post('/auth/login.php', credentials),
  forgotPassword: (email) => api.post('auth/forgot-user-password.php', email),
  resetPassword: (resetData) => api.post('auth/reset-password.php', resetData),
  verifyToken: () => api.post('/auth/verify-token.php'),
};

export const reviewAPI = {
  getReviews: (params = {}) => api.get('/reviews/', { params }),
  submitReview: (token, reviewData) => api.post(`/reviews/?token=${token}`, reviewData),
};

export default api;